module.exports = __webpack_public_path__ + "static/img/1_6.fd552f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_6.png
// module id = 2M1r
// module chunks = 0